import styled from 'styled-components';

export const SignupNicknameSection = styled.div`
    padding: 0 calc(100vw*(20/375));
    height: 100%;
    overflow-y: scroll;
`;

export const NicknameBlock = styled.div`
    margin-top: calc(100vh * (43 / 812));
`;

export const InputElementTitle = styled.h3`
    font-weight: 700;
    font-size: calc(100vw * (23 / 375));
    line-height: calc(100vw * (28 / 375));
`;

export const NicknameInputBlock = styled.div`
    position: relative;
    margin-top: calc(100vw * (16 / 375));
`;

export const InputStyle = styled.input`
    border: 1px solid #D5D5D5;
    border-radius: calc(100vw * (5 / 375));
    width: 100%;
    padding: calc(100vw * (11 / 375));
    &:focus {
        border: 1px solid #FFCF19;
    }
    &::placeholder {
        font-size: calc(100vw * (14 / 375));
        color: #C6C6C6;
    }
    &.error_active {
        border 1px solid #de0000;
    }
`;

export const DeleteButton = styled.button`
    position: absolute;
    top: 50%;
    right: 5%;
    height: calc(100vw * (18 / 375));
    transform: translate(0, -50%);
`;

export const DeleteIcon = styled.img`
    width: calc(100vw * (18 / 375));
`;

export const ErrorBlock = styled.div`
    margin-top: calc(100vw * (4 / 375));
`;

export const ErrorIcon = styled.img`
    width: calc(100vw * (12 / 375));
    margin-right: calc(100vw * (4.5 / 375));
`;

export const ErrorMessage = styled.p`
    display: inline-block;
    font-size: calc(100vw * (10 / 375));
    color: #de0000;
    
`;